import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Rating, Grid, Paper, Typography } from '@mui/material';

// The fill color is based on the value passed to the Rating component.
// The SVG icon's color will match the rank (value) of the rating.
const fireIconTheme = createTheme({
  components: {
    MuiRating: {
      styleOverrides: {
        icon: {
          color: 'var(--icon-color)',
        },
      },
      defaultProps: {
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="currentColor" 
                width="24px" 
                height="24px">
              <path d="M12 2C12 2 8 6 8 10c0 2.21 1.79 4 4 4s4-1.79 4-4c0-4-4-8-4-8zm0 20c4.42 0 8-3.58 8-8 0-3.72-2.55-6.85-6-7.75.67 1.28 1 2.63 1 3.75 0 3.31-2.69 6-6 6-1.12 0-2.47-.33-3.75-1 0 3.45 3.03 7 6.75 7z"/>
            </svg>
          ),
          emptyIcon: (
            <svg xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                width="24px" 
                height="24px">
              <path d="M12 2C12 2 8 6 8 10c0 2.21 1.79 4 4 4s4-1.79 4-4c0-4-4-8-4-8zm0 20c4.42 0 8-3.58 8-8 0-3.72-2.55-6.85-6-7.75.67 1.28 1 2.63 1 3.75 0 3.31-2.69 6-6 6-1.12 0-2.47-.33-3.75-1 0 3.45 3.03 7 6.75 7z"/>
            </svg>
          ),
      },
    },
  },
});

const categorizeAndSortData = (data) => {
  const categories = ["SHRUB", "HERBACEOUS", "HARDWOOD", "CONIFER"];
  const categorizedData = {};

  categories.forEach(category => {
    const filteredData = data.fuel_risk.data
      .filter(item => item.category === category)
      .sort((a, b) => {
        if (b.value !== a.value) {
          return b.value - a.value;
        }
        return a.miles - b.miles;
      });

    const highestValue = filteredData.reduce((max, item) => Math.max(max, item.value), 0);

    categorizedData[category] = {
      rank: highestValue,
      details: filteredData.map(item => ({
        name: item.name,
        miles: item.miles,
        value: item.value
      }))
    };
  });

  return categorizedData;
};

const RiskRatings = ({ rank }) => {
  //const processedData = categorizeAndSortData(data);

  // The Rating component needs a style prop to pass the color variable to the theme
  const ratingColors = {
    1: '#fcd34d', // yellow-300
    2: '#eab308', // yellow-500
    3: '#f97316', // orange-500
    4: '#dc2626', // red-600
    5: '#7f1d1d', // red-900
  };

  return (
    <ThemeProvider theme={fireIconTheme}>



            <Paper 
              className="p-6 bg-gray-700 rounded-xl shadow-inner border border-gray-600 h-full flex flex-col items-center justify-center text-center"
              sx={{ width: "120px", p: 2 }}
            >
              <Rating
                name={`rating`}
                value={rank}
                readOnly
                size="large"
                // Pass the color to the CSS variable
                sx={{ '--icon-color': ratingColors[rank] }}
              />
            </Paper>

    </ThemeProvider>
  );
};

export default RiskRatings;
